export enum Status {
    ACTIVATION_PENDING = "AP",
    ACTIVE = "AC",
    INACTIVE = "IN",
    DISABLED = "DI",
    //TODO BACKEND quais os status disponiveis
}

export enum TaskStatus {
    CR = "Criado",
    EN = "Enviado",
    PR = "Processando",
    ER = "Erro",
    OK = "Concluído"
}
